import Controller from '@ember/controller'
import { tracked } from '@glimmer/tracking'

export default class BookLibraryCollectionShowController extends Controller {
  queryParams = ['primaryFilterKey', 'sort', 'selected']

  @tracked sort = 'title'

  @tracked selected = ''

  @tracked primaryFilterKey?: string
}
